// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store, { types } from './store';
import http from './http';
import { sync } from 'vuex-router-sync';

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VCard,
  VImg,
  VAvatar,
  VBtn,
  VIcon,
  VGrid,
  VTabs,
  VAlert,
  VTextField,
  VForm,
  VToolbar,
  transitions,
  VDivider,
  VProgressCircular,
  VChip,
} from 'vuetify';
import '../node_modules/vuetify/src/stylus/app.styl';
import moment from 'moment';
import BarChart from '@/components/BarChart';

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VCard,
    VImg,
    VAvatar,
    VBtn,
    VIcon,
    VGrid,
    VTabs,
    VAlert,
    VTextField,
    VForm,
    VToolbar,
    transitions,
    VDivider,
    VProgressCircular,
    VChip,
  },
  theme: {
    primary: '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
});

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.http = http;
window.http = http;
window._ = require('lodash');

sync(store, router);
store.dispatch(types.GET_AUTH);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, BarChart },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js